import { type MaintenancePdfPlacement } from '@gb-ticket/shared-types';
import { type CSSProperties } from 'react';

export function acroformFieldBoxStyle(placement: MaintenancePdfPlacement): CSSProperties {
  return {
    left: `${placement.x * 100}%`,
    top: `${placement.y * 100}%`,
    width: `${Math.max(placement.width, 0) * 100}%`,
    height: `${Math.max(placement.height, 0) * 100}%`,
    minWidth: 0,
    minHeight: 0,
  };
}
